import { trackAnalyticsEvent } from "./gtmDataLayer";

const GTM_EVENTS_ARRAY = [
  "course_overview",
  "course_content_tab_click",
  "course_like_click",
  "course_coupon_applied",
  "course_buy_now_click",
  "course_pay_via_installments",
  "course_payment_successful_new",
  "course_payment_successful",
  "course_payment_failed",
  "course_share_click",
];

/**
 * Forwards allowlisted events to the native GTM bridge
 * (Android `window.mobile.onGTMEvent`, iOS WKWebView `onGTMEvent`).
 *
 * Crash fix: Android `@JavascriptInterface` methods run synchronously. If Java
 * throws (invalid/nested payload, too many Firebase params, null/NaN numbers,
 * etc.), Chromium surfaces:
 *   "Error invoking onGTMEvent: Java exception was raised during method invocation"
 * That used to be uncaught and could kill the WebView (reported as `at mB` in
 * minified stacks). Deeplink helpers already wrap native calls in try/catch;
 * this does the same so a bad GTM payload never takes down the course screen.
 *
 * `exception_handled` is sent via `trackAnalyticsEvent` (Netlify → GA4), not
 * back through `onGTMEvent`, so a failing native call cannot recurse.
 */
export const gtmTrackEvents = (name, properties) => {
  // Same allowlist as before: newWebEngage() fires many events; only these
  // should hit the native GTM bridge.
  if (!GTM_EVENTS_ARRAY.includes(name)) return;

  const payload = JSON.stringify({
    event: name,
    properties: {
      ...properties,
    },
  });

  try {
    window?.mobile?.onGTMEvent?.(payload);
  } catch (error) {
    // Swallow the Java exception so the WebView stays up; record it in GA4.
    trackAnalyticsEvent("exception_handled", {
      source: "onGTMEvent",
      platform: "android",
      original_event: name,
      message: error?.message || "Unknown error",
    });
  }

  try {
    window?.webkit?.messageHandlers?.onGTMEvent?.postMessage(payload);
  } catch (error) {
    // Same protection for iOS WKWebView messageHandlers (can throw too).
    trackAnalyticsEvent("exception_handled", {
      source: "onGTMEvent",
      platform: "ios",
      original_event: name,
      message: error?.message || "Unknown error",
    });
  }
};
